import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { MsalBroadcastService, MsalService } from '@azure/msal-angular';
import { InteractionStatus } from '@azure/msal-browser';
import { AuthInternalService } from '@vinnova/auth-internal';
import { filter, map, of, switchMap, take } from 'rxjs';

export const popupAuthGuard: CanActivateFn = () => {
  const msalService = inject(MsalService);
  const msalBroadcastService = inject(MsalBroadcastService);
  const authInternalService = inject(AuthInternalService);

  return msalService.initialize().pipe(
    switchMap(() => msalBroadcastService.inProgress$),
    filter((status) => status === InteractionStatus.None),
    take(1),
    switchMap(() => {
      if (authInternalService.isLoggedIn()) {
        return of(true);
      }
      return authInternalService.loginPopup(false).pipe(map(() => true));
    }),
  );
};
